import { HStack, Link } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { createPortal } from 'react-dom';
import { AppContext } from '../comments/AppContext';
import React from 'react';
import { TEMPLATE } from '@/shared/constants';
import { AuthService } from '../services/AuthService';

export const AppLinkBar = () => {

  const { isAuthenticated } = React.useContext(AppContext);

  const items = React.useMemo(() => [
    ...(isAuthenticated ? [{ label: 'Resources', href: `/page/${TEMPLATE.PAGE_RESOURCES}` }] : []),
    ...(AuthService.isStaff ? [{ label: 'Analytics', href: `/page/${TEMPLATE.PAGE_ANALYTICS}` }] : []),
    ...(AuthService.isAdmin ? [{ label: 'Admin', href: `/admin` }] : []),
  ], [isAuthenticated]);


  const linkbarElement = document.getElementById('eitum-linkbar');
  if (!linkbarElement) {
    return null;
  }

  return createPortal(
    <HStack spacing={4}>
      {items.map((item, index) => (
        <Link key={index} as={RouterLink} color='white' _hover={{ color: 'white', textDecoration: 'underline' }} to={item.href}>{item.label}</Link>
      ))}
    </HStack>
    , linkbarElement
  );
}
